// extracted by mini-css-extract-plugin
export default {"tag":"CategoryTag_tag__mx+go","focus":"CategoryTag_focus__vI98r","distraction":"CategoryTag_distraction__WHlx7","other":"CategoryTag_other__1-rXi"};